import { IncapacitatedReportCriteria } from '@src/main/modules/reports/incapacitated/domain/incapacitated-report.interface';
import { IncapacitatedReportRepository } from '@src/main/modules/reports/incapacitated/domain/incapacitated-report.repository';

export const findIncapacitatedReports = (
  repository: IncapacitatedReportRepository,
  criteria: IncapacitatedReportCriteria,
) => repository.findByCriteria(criteria);
